import { render, staticRenderFns } from "./aFold.vue?vue&type=template&id=f252be4c&scoped=true&"
import script from "./aFold.vue?vue&type=script&lang=js&"
export * from "./aFold.vue?vue&type=script&lang=js&"
import style0 from "./aFold.vue?vue&type=style&index=0&id=f252be4c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f252be4c",
  null
  
)

export default component.exports